module.exports = __webpack_public_path__ + "static/media/poultry-1.ffefba13.svg";